import { createContext } from 'react';
import type { ColumnHeaderContextValue } from '../types';

export const ColumnHeaderContext = createContext<ColumnHeaderContextValue | undefined>(undefined);
